// ============================================================
// CONTENUTI DEL SITO — modifica solo questo file per aggiornare
// testi, esperienze e contatti. Nessuna logica da toccare.
// Versione italiana + inglese (toggle IT/EN nella menu bar).
// ============================================================

export const site = {
    firstName: "Fabrizio",
    lastName: "Guidi",
    name: "Fabrizio Guidi",
    role: "Esperto di formazione del personale nella Pubblica Amministrazione",
    tagline: "Dare a chiunque la possibilità di accedere alla cultura.",
    intro: "Corsi, workshop, seminari e conferenze. Formazione in presenza ed e-learning nella Pubblica Amministrazione.",
    ctaLinkedin: "Connettiti su LinkedIn",
    scrollLabel: "Scorri",
    windowWelcome: "Benvenuto",
    domain: "fabrizioguidi.eu",
    email: "fabrizio@fabrizioguidi.eu",
    emailSubject: "Mail al Sito.",
    linkedin: "https://www.linkedin.com/in/fabrizioguidi",
    linkedinLabel: "linkedin.com/in/fabrizioguidi",
    cvUrl: process.env.PUBLIC_URL + "/cv-fabrizio-guidi.pdf",
    onlineSinceText: "Online dall'8 maggio 2008",
};

export const marqueeItems = [
    "Formazione",
    "Pubblica Amministrazione",
    "E-learning",
    "Cultura accessibile a tutti",
    "Corsi & Workshop",
    "Seminari & Conferenze",
    "Generazione Y",
    "Dammi 5 minuti",
];

export const chiSono = {
    windowTitle: "Chi sono",
    overline: "01 — Chi sono",
    heading: "La cultura è di tutti.",
    chapters: [
        {
            number: "01",
            title: "Il mio desiderio",
            body: "«Mi piacerebbe che… la gente possa connettersi gratuitamente alla Rete. Penso che sia necessario dare a chiunque la possibilità di accedere alla cultura e non solo.» È il desiderio con cui questo sito è nato, l'8 maggio 2008, e che continua a guidare il mio lavoro nella formazione.",
        },
        {
            number: "02",
            title: "Dammi 5 minuti",
            body: "«Dammi 5 minuti»: nel parlare comune ci si esprime sempre più spesso così. Dammi 5 minuti, si chiede alla sveglia la mattina; mi preparo in 5 minuti; dammi 5 minuti e sarò da te; faccio la doccia in 5 minuti, mangio in 5 minuti, faccio il caffè in 5 minuti. Cinque minuti possono bastare a cambiare il risultato di una partita di calcio; anche in 5 minuti possiamo vincere al Superenalotto e cambiare questa vita — auspicando che la salute non ci abbandoni in 5 minuti! Datevi del tempo. Godetevi la vita.",
        },
    ],
    image: {
        url: process.env.PUBLIC_URL + "/fotopersonale.png",
        alt: "Fabrizio Guidi",
        caption: "Fabrizio Guidi.",
        titlebar: "ritratto.pict",
    },
};

// Punto 03 di Chi sono
export const progetti = {
    title: "Progetti e storia",
    itemsLabel: "Progetti & blog",
    storia: [
        {
            date: "8 maggio 2008",
            title: "L'inaugurazione",
            text: "Questa pagina va online per la prima volta, mentre a Roma è in visita Mr. Al Gore, futuro ex presidente degli Stati Uniti d'America.",
            link: "https://www.generazioney.eu/2008/05/09/current-tv-ora-anche-tu-puoi-dire-la-tua/",
            linkLabel: "Leggi l'articolo",
        },
        {
            date: "8 maggio 2014",
            title: "Il nuovo blog",
            text: "A sei anni dall'inaugurazione del sito nasce il nuovo blog.",
            link: "http://www.generazioney.eu",
            linkLabel: "Visita il blog",
        },
    ],
    items: [
        {
            name: "CarPuter Y",
            note: "Progetto su Flickr",
            url: "http://www.flickr.com/photos/fgoose68/sets/72157628878937179/",
        },
        {
            name: "Commodore 64 restyling",
            note: "Progetto su Flickr",
            url: "http://www.flickr.com/photos/fgoose68/sets/72157628878855347/",
        },
        {
            name: "Generazione Y",
            note: "Il blog",
            url: "http://www.generazioney.eu",
        },
    ],
    quote: {
        text: "Ci sono abbastanza risorse nel mondo per i bisogni dell'uomo. Non per la sua avidità.",
        author: "Mohandas Karamchand Gandhi, 1949",
    },
};

// Punto 04 di Chi sono
export const personale = {
    title: "Qualcosa di personale",
    schedaLabel: "Carta d'identità",
    date: [
        { year: "1987", text: "Mi diplomo Perito Industriale, specializzazione Elettronica." },
        { year: "1992", text: "Vinco un concorso pubblico, quale Ispettore." },
        {
            year: "1994 — 2004",
            text: "Vivo e lavoro in Lombardia: corsi di informatica, microprocessori e internet. E la fortuna di conoscere dei veri amici.",
        },
        { year: "2004", text: "Mi laureo in Economia e Commercio all'Università di Bologna." },
        { year: "2008", text: "Creo la prima pagina di questo sito su Internet." },
    ],
    scheda: [
        { label: "Classe", value: "1968" },
        { label: "Vivo a", value: "Roma, Italia" },
        { label: "Studi", value: "Laurea — Università di Bologna" },
        { label: "Occupazione", value: "Impiegato" },
        { label: "Hobby", value: "Informatica" },
        { label: "Interessi", value: "Economia" },
        { label: "Computer", value: "iMac" },
        { label: "Vacanze", value: "Grecia, Francia, Spagna e Olanda — e la Sardegna, almeno in Italia, non è da meno" },
    ],
    motto: "Chi passa al Mac, non torna più indietro.",
    preferiti: [
        {
            title: "In cuffia",
            text: "Natalie Imbruglia, Madonna, Nelly Furtado, Alanis Morissette, R.E.M., U2, Pet Shop Boys e Simply Red.",
        },
        {
            title: "Sul comodino",
            text: "Film preferito: Ghost. Rivista: iCreate (non c'è più).",
        },
        {
            title: "Sul web",
            text: "www.algore.com · www.theapplelounge.com",
            links: [
                { label: "spider-mac.com", url: "https://spider-mac.com" },
                { label: "www.macitynet.it", url: "https://www.macitynet.it/" },
            ],
        },
    ],
};

export const esperienza = {
    windowTitle: "Esperienza / CV",
    overline: "02 — Esperienza",
    heading: "Esperienza.",
    cvButton: "Scarica il CV in PDF",
    skillsTitle: "Competenze chiave",
    specialtiesTitle: "Specialties",
    ambitiTitle: "Ambiti",
    timeline: [
        {
            years: "2011 — Oggi",
            role: "Organizzazione di eventi e attività formative",
            org: "Online e in presenza",
            description:
                "Organizzo eventi, seminari e attività formative online e in presenza, in tematiche operativo-tributarie, di aggiornamento professionale e in materia di Sicurezza sul Lavoro.",
        },
        {
            years: "2010 — 2011",
            role: "Procedimenti disciplinari",
            org: "Gestione del personale",
            description:
                "Trattazioni concernenti il personale nell'ambito dei procedimenti disciplinari.",
        },
        {
            years: "2003 — 2010",
            role: "Verifiche fiscali, accessi e ispezioni",
            org: "Provincia di Roma",
            description:
                "Attività di verifiche fiscali, accessi e ispezioni, nonché accertamenti bancari, in ambito territoriale della provincia di Roma.",
        },
        {
            years: "2000 — 2003",
            role: "Trattazioni del personale e statistiche operative",
            org: "Lombardia",
            description:
                "Gestione delle trattazioni relative al personale e delle statistiche operative; organizzazione di accessi e verifiche presso studi di avvocati e commercialisti e aziende operanti in Lombardia.",
        },
        {
            years: "1994 — 2000",
            role: "Polizia Giudiziaria e Polizia Economico-Finanziaria",
            org: "Italia",
            description:
                "Esperienze nell'attività di Polizia Giudiziaria italiana e nell'attività di Polizia Economico-Finanziaria italiana: controlli strumentali, ispezioni, accessi e verifiche.",
        },
    ],
    skills: [
        "Conoscenze approfondite del pacchetto Microsoft Office e dei sistemi operativi Windows XP, 7 e macOS Leopard, Lion, Mountain Lion, Mojave e Tahoe",
        "Esperienza nella progettazione e gestione di siti web",
        "Conoscenze approfondite della navigazione nel World Wide Web, home banking e PayPal",
        "Tutor di piattaforma Moodle",
        "Buona conoscenza della programmazione in ambito Intelligenza Artificiale per la realizzazione di WebApp con il supporto di Docker e attività correlate",
    ],
    specialties: [
        "Attestato di Specializzazione post-diploma in Elettronica Industriale con Sistemi a Microprocessori",
        "Certificato di Frequenza e Profitto in Internet e Editoria Elettronica",
    ],
    ambiti: [
        {
            title: "In aula",
            text: "Corsi, workshop e seminari in presenza: metodo interattivo, casi reali, lavoro sui gruppi.",
        },
        {
            title: "Su piattaforme e-learning",
            text: "Corsi asincroni, webinar e classi virtuali: contenuti progettati per il digitale, non adattati.",
        },
    ],
};

export const contatti = {
    windowTitle: "Contatti",
    overline: "03 — Contatti",
    heading: "Parliamone.",
    note: "Per collaborazioni formative o inviti quali relatori ai corsi, per le opportune verifiche, il modo più semplice è scrivermi.",
    thanks: "Un saluto e un vivo ringraziamento al mio amico Graziano, per il supporto tecnico nella realizzazione di questo sito.",
    footerTag: "Creato con un Mac!",
};

export const privacy = {
    windowTitle: "Privacy",
    overline: "04 — Privacy",
    heading: "Privacy.",
    blocks: [
        {
            title: "Titolare del trattamento",
            text: "Fabrizio Guidi — fabrizio@fabrizioguidi.eu.",
        },
        {
            title: "Nessuna raccolta dati",
            text: "Questo sito non raccoglie dati personali, non utilizza cookie di profilazione né strumenti di analisi. La navigazione è libera e anonima.",
        },
        {
            title: "Contatti",
            text: "Se mi scrivi via email o LinkedIn, i dati che fornisci (nome e indirizzo email) sono utilizzati esclusivamente per rispondere al tuo messaggio, nel rispetto del Regolamento UE 2016/679 (GDPR).",
        },
        {
            title: "Link esterni",
            text: "LinkedIn, Flickr, Spider-Mac, Macitynet e il blog Generazione Y sono servizi esterni con proprie informative privacy, alle quali si rimanda.",
        },
        {
            title: "I tuoi diritti",
            text: "Puoi esercitare i diritti previsti dagli articoli 15–22 del GDPR (accesso, rettifica, cancellazione) scrivendo a fabrizio@fabrizioguidi.eu.",
        },
    ],
};

// ============================================================
// ENGLISH VERSION
// ============================================================

export const en = {
    site: {
        ...site,
        role: "Staff training expert for the Italian Public Administration",
        tagline: "Giving everyone the chance to access culture.",
        intro: "Courses, workshops, seminars and conferences. In-person and e-learning training for the Public Administration.",
        ctaLinkedin: "Connect on LinkedIn",
        scrollLabel: "Scroll",
        windowWelcome: "Welcome",
        emailSubject: "Mail to the site.",
        onlineSinceText: "Online since May 8, 2008",
    },
    marqueeItems: [
        "Training",
        "Public Administration",
        "E-learning",
        "Culture accessible to all",
        "Courses & Workshops",
        "Seminars & Conferences",
        "Generazione Y",
        "Dammi 5 minuti",
    ],
    chiSono: {
        ...chiSono,
        windowTitle: "About me",
        overline: "01 — About me",
        heading: "Culture belongs to everyone.",
        chapters: [
            {
                number: "01",
                title: "My wish",
                body: "\"I wish… that people could connect to the Internet for free. I believe everyone should have the chance to access culture — and not only that.\" This is the wish the site was born with, on May 8, 2008, and it still guides my work in training.",
            },
            {
                number: "02",
                title: "Give me 5 minutes",
                body: "\"Give me 5 minutes\": people say it more and more often. We ask the alarm clock for 5 more minutes in the morning; I'll be ready in 5 minutes; give me 5 minutes and I'll be with you; I shower in 5 minutes, eat in 5 minutes, make coffee in 5 minutes. Five minutes can be enough to change the result of a football match; even in 5 minutes we can win the lottery and change this life — hoping our health doesn't leave us in 5 minutes! Give yourself time. Enjoy life.",
            },
        ],
        image: {
            ...chiSono.image,
            caption: "Fabrizio Guidi.",
        },
    },
    progetti: {
        title: "Projects & history",
        itemsLabel: "Projects & blog",
        storia: [
            {
                date: "May 8, 2008",
                title: "The launch",
                text: "This page goes online for the first time, while Mr. Al Gore, future former President of the United States of America, is visiting Rome.",
                link: "https://www.generazioney.eu/2008/05/09/current-tv-ora-anche-tu-puoi-dire-la-tua/",
                linkLabel: "Read the article (IT)",
            },
            {
                date: "May 8, 2014",
                title: "The new blog",
                text: "Six years after the site launched, the new blog is born.",
                link: "http://www.generazioney.eu",
                linkLabel: "Visit the blog (IT)",
            },
        ],
        items: [
            {
                name: "CarPuter Y",
                note: "Project on Flickr",
                url: "http://www.flickr.com/photos/fgoose68/sets/72157628878937179/",
            },
            {
                name: "Commodore 64 restyling",
                note: "Project on Flickr",
                url: "http://www.flickr.com/photos/fgoose68/sets/72157628878855347/",
            },
            {
                name: "Generazione Y",
                note: "The blog (IT)",
                url: "http://www.generazioney.eu",
            },
        ],
        quote: {
            text: "There are enough resources in the world for man's needs. Not for his greed.",
            author: "Mohandas Karamchand Gandhi, 1949",
        },
    },
    personale: {
        title: "Something personal",
        schedaLabel: "ID card",
        date: [
            { year: "1987", text: "I graduate as an Industrial Technician, specialising in Electronics." },
            { year: "1992", text: "I pass a public competition, as an Inspector." },
            {
                year: "1994 — 2004",
                text: "I live and work in Lombardy: courses in computing, microprocessors and the internet. And the luck of meeting true friends.",
            },
            { year: "2004", text: "I graduate in Economics at the University of Bologna." },
            { year: "2008", text: "I create this site's first page on the Internet." },
        ],
        scheda: [
            { label: "Born", value: "1968" },
            { label: "Based in", value: "Rome, Italy" },
            { label: "Education", value: "Degree — University of Bologna" },
            { label: "Occupation", value: "Employee" },
            { label: "Hobby", value: "Computing" },
            { label: "Interests", value: "Economics" },
            { label: "Computer", value: "iMac" },
            { label: "Holidays", value: "Greece, France, Spain and the Netherlands — and Sardinia, at least in Italy, is no less" },
        ],
        motto: "Once you go Mac, you never go back.",
        preferiti: [
            {
                title: "On my headphones",
                text: "Natalie Imbruglia, Madonna, Nelly Furtado, Alanis Morissette, R.E.M., U2, Pet Shop Boys and Simply Red.",
            },
            {
                title: "On the bedside table",
                text: "Favourite film: Ghost. Magazine: iCreate (no longer published).",
            },
            {
                title: "On the web",
                text: "www.algore.com · www.theapplelounge.com",
                links: [
                    { label: "spider-mac.com", url: "https://spider-mac.com" },
                    { label: "www.macitynet.it", url: "https://www.macitynet.it/" },
                ],
            },
        ],
    },
    esperienza: {
        windowTitle: "Experience / CV",
        overline: "02 — Experience",
        heading: "Experience.",
        cvButton: "Download CV (PDF)",
        skillsTitle: "Key skills",
        specialtiesTitle: "Specialties",
        ambitiTitle: "Areas",
        timeline: [
            {
                years: "2011 — Today",
                role: "Event and training organisation",
                org: "Online and in person",
                description:
                    "I organise events, seminars and training activities online and in person, on operational and tax topics, professional development and Workplace Safety.",
            },
            {
                years: "2010 — 2011",
                role: "Disciplinary proceedings",
                org: "Staff management",
                description:
                    "Matters concerning staff within disciplinary proceedings.",
            },
            {
                years: "2003 — 2010",
                role: "Tax audits, accesses and inspections",
                org: "Province of Rome",
                description:
                    "Tax audits, accesses and inspections, as well as bank assessments, in the territory of the province of Rome.",
            },
            {
                years: "2000 — 2003",
                role: "Staff matters and operational statistics",
                org: "Lombardy",
                description:
                    "Management of staff matters and operational statistics; organisation of accesses and audits at law and accountancy firms and at companies operating in Lombardy.",
            },
            {
                years: "1994 — 2000",
                role: "Judicial Police and Economic-Financial Police",
                org: "Italy",
                description:
                    "Experience in Italian Judicial Police and Economic-Financial Police activities: instrumental controls, inspections, accesses and audits.",
            },
        ],
        skills: [
            "In-depth knowledge of the Microsoft Office suite and operating systems: Windows XP, 7 and macOS Leopard, Lion, Mountain Lion, Mojave and Tahoe",
            "Experience in website design and management",
            "In-depth knowledge of World Wide Web navigation, home banking and PayPal",
            "Moodle platform Tutor",
            "Good knowledge of Artificial Intelligence programming for building WebApps with Docker support and related activities",
        ],
        specialties: [
            "Post-diploma Specialisation Certificate in Industrial Electronics with Microprocessor Systems",
            "Certificate of Attendance and Proficiency in Internet and Electronic Publishing",
        ],
        ambiti: [
            {
                title: "In the classroom",
                text: "In-person courses, workshops and seminars: interactive method, real cases, group work.",
            },
            {
                title: "On e-learning platforms",
                text: "Asynchronous courses, webinars and virtual classes: content designed for digital, not adapted.",
            },
        ],
    },
    contatti: {
        windowTitle: "Contact",
        overline: "03 — Contact",
        heading: "Let's talk.",
        note: "For training collaborations or invitations as a speaker at courses, and for any appropriate checks, the easiest way is to write to me.",
        thanks: "A greeting and a warm thank you to my friend Graziano, for the technical support in building this site.",
        footerTag: "Made with a Mac!",
    },
    privacy: {
        windowTitle: "Privacy",
        overline: "04 — Privacy",
        heading: "Privacy.",
        blocks: [
            {
                title: "Data controller",
                text: "Fabrizio Guidi — fabrizio@fabrizioguidi.eu.",
            },
            {
                title: "No data collection",
                text: "This site does not collect personal data and does not use profiling cookies or analytics tools. Browsing is free and anonymous.",
            },
            {
                title: "Contact",
                text: "If you write to me by email or LinkedIn, the data you provide (name and email address) is used solely to reply to your message, in compliance with EU Regulation 2016/679 (GDPR).",
            },
            {
                title: "External links",
                text: "LinkedIn, Flickr, Spider-Mac, Macitynet and the Generazione Y blog are external services with their own privacy policies.",
            },
            {
                title: "Your rights",
                text: "You can exercise the rights set out in Articles 15–22 of the GDPR (access, rectification, erasure) by writing to fabrizio@fabrizioguidi.eu.",
            },
        ],
    },
};
